import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getPigletFeedInformation, getPigletFeedInformationAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_PIGLET_FEED_INFORMATION } from "consts";

export const useGetFootprintingPigletFeedInformationByPrimaryDataId = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_PIGLET_FEED_INFORMATION, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getPigletFeedInformationAdmin(primaryDataId) : getPigletFeedInformation(primaryDataId)),
      enabled: !!primaryDataId,
      gcTime: 60000,
    },
    queryClient
  );
};
